(function () {
  function handleize(str) {
    str = String(str == null ? '' : str).toLowerCase();
    if (str.normalize) str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    str = str.replace(/ø/g, 'o').replace(/æ/g, 'ae').replace(/å/g, 'a');
    str = str.replace(/[^a-z0-9\s-]/g, '');
    str = str.trim().replace(/\s+/g, '-').replace(/-+/g, '-');
    return str;
  }

  function parseMap(raw) {
    raw = String(raw || '').trim();
    if (!raw) return {};
    var out = {};
    raw.split(',').forEach(function (pair) {
      pair = String(pair || '').trim();
      if (!pair) return;
      var idx = pair.indexOf(':');
      if (idx === -1) return;
      var key = handleize(pair.slice(0, idx).trim());
      var value = handleize(pair.slice(idx + 1).trim());
      if (!key || !value) return;
      out[key] = value;
    });
    return out;
  }

  /* AMOK: gallery alt "Name / a, b / c" -> slide classes hc-a hc-b hc-c. A slide matches a dimension (size / colour)
     when it has the selected value's class, or when it has no class from that dimension's value set at all
     (= image not tagged for that dimension -> shown for every value of it). */
  function getSlideTokens(slide) {
    if (slide.__hcTokens) return slide.__hcTokens;
    var out = Object.create(null);
    var cls = slide.classList;
    for (var i = 0; i < cls.length; i++) {
      var name = cls[i];
      if (name.indexOf('hc-') !== 0) continue;
      var t = handleize(name.slice(3));
      if (t) out[t] = true;
    }
    slide.__hcTokens = out;
    return out;
  }

  function buildValueSet(raw, mapA, mapB, extra) {
    if (raw == null) return null;
    var set = Object.create(null);
    function add(v) {
      v = handleize(v);
      if (!v) return;
      set[v] = true;
      if (mapA && Object.prototype.hasOwnProperty.call(mapA, v) && mapA[v]) set[mapA[v]] = true;
      if (mapB && Object.prototype.hasOwnProperty.call(mapB, v) && mapB[v]) set[mapB[v]] = true;
    }
    String(raw).split(',').forEach(function (v) { add(String(v).trim()); });
    (extra || []).forEach(function (v) { if (v) add(v); });
    return set;
  }

  function matchesDimension(tokens, val, valueSet) {
    if (!val) return true;
    if (tokens[val]) return true;
    if (!valueSet) return false;
    for (var k in valueSet) {
      if (tokens[k]) return false;
    }
    return true;
  }

  function findVariantWraps() {
    return Array.prototype.slice.call(document.querySelectorAll('.variant-input-wrap'));
  }

  function getSelectedFromWrap(wrap) {
    if (!wrap) return '';
    var checked = wrap.querySelector('input[type="radio"]:checked');
    if (checked) {
      var vi = checked.closest('.variant-input');
      if (vi) {
        var dv = vi.getAttribute('data-default-value');
        if (dv) return handleize(dv);
      }
      if (checked.value) return handleize(checked.value);
    }
    var sel = wrap.querySelector('select');
    if (sel && sel.value) return handleize(sel.value);
    return '';
  }

  function detectIndexByName(keys) {
    var wraps = findVariantWraps();
    for (var i = 0; i < wraps.length; i++) {
      var label = wraps[i].getAttribute('data-handle') || wraps[i].getAttribute('name') || wraps[i].getAttribute('data-index') || '';
      label = handleize(label);
      for (var j = 0; j < keys.length; j++) {
        if (label === keys[j]) return i;
      }
    }
    return -1;
  }

  function getSelectedByIndex(index) {
    var wraps = findVariantWraps();
    if (!wraps.length || index < 0 || index >= wraps.length) return '';
    return getSelectedFromWrap(wraps[index]);
  }

  function restoreWrapperFromTemplate(sliderEl) {
    var wrapperEl = sliderEl.querySelector('.swiper-wrapper');
    if (!wrapperEl) return null;

    var tpl = sliderEl.querySelector('template.hc-gallery-master');
    if (tpl && typeof tpl.innerHTML === 'string' && tpl.innerHTML.trim()) {
      wrapperEl.innerHTML = tpl.innerHTML;
      return wrapperEl;
    }

    if (!sliderEl.__hcFallbackMaster) sliderEl.__hcFallbackMaster = wrapperEl.innerHTML;
    wrapperEl.innerHTML = sliderEl.__hcFallbackMaster;
    return wrapperEl;
  }

  function initSwiper(sliderEl) {
    if (typeof Swiper === 'undefined') return null;
    if (sliderEl.__hcSwiper) return sliderEl.__hcSwiper;

    sliderEl.__hcSwiper = new Swiper(sliderEl, {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      slidesPerScroll: 1,
      speed: 600,
      centeredSlides: true,
      autoHeight: true,
      pagination: { el: sliderEl.querySelector('.swiper-pagination') },
      navigation: {
        nextEl: sliderEl.querySelector('.swiper-button-next'),
        prevEl: sliderEl.querySelector('.swiper-button-prev')
      },
      effect: 'fade',
      fadeEffect: { crossFade: true }
    });

    return sliderEl.__hcSwiper;
  }

  function destroySwiper(sliderEl) {
    if (sliderEl.__hcSwiper && sliderEl.__hcSwiper.destroy) {
      sliderEl.__hcSwiper.destroy(true, true);
    }
    sliderEl.__hcSwiper = null;
    sliderEl.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-vertical');
  }

  function resolveColorValue(sliderEl, wrapperEl, colorVal) {
    colorVal = handleize(colorVal);
    if (!colorVal) return '';
    if (wrapperEl.querySelector('.hc-' + colorVal)) return colorVal;

    var mapEnNo = parseMap(sliderEl.getAttribute('data-hc-map-en-no'));
    var mapNoEn = parseMap(sliderEl.getAttribute('data-hc-map-no-en'));

    if (mapEnNo[colorVal] && wrapperEl.querySelector('.hc-' + mapEnNo[colorVal])) return mapEnNo[colorVal];
    if (mapNoEn[colorVal] && wrapperEl.querySelector('.hc-' + mapNoEn[colorVal])) return mapNoEn[colorVal];

    return colorVal;
  }

  function filterSlides(sliderEl) {
    var wrapperEl = restoreWrapperFromTemplate(sliderEl);
    if (!wrapperEl) return;

    var sizeIndex = sliderEl.hasAttribute('data-size-index') ? parseInt(sliderEl.getAttribute('data-size-index') || '0', 10) : -1;
    var colorIndex = sliderEl.hasAttribute('data-color-index') ? parseInt(sliderEl.getAttribute('data-color-index') || '0', 10) : -1;

    if (sizeIndex < 0) sizeIndex = detectIndexByName(['size', 'storrelse', 'storlek', 'grosse', 'groesse']);
    if (colorIndex < 0) colorIndex = detectIndexByName(['color', 'colour', 'farge', 'farg', 'farbe']);

    var sizeVal = sizeIndex >= 0 ? handleize(sliderEl.getAttribute('data-value-' + sizeIndex) || '') : '';
    var colorVal = colorIndex >= 0 ? handleize(sliderEl.getAttribute('data-value-' + colorIndex) || '') : '';

    if (!sizeVal && sizeIndex >= 0) sizeVal = getSelectedByIndex(sizeIndex);
    if (!colorVal && colorIndex >= 0) colorVal = getSelectedByIndex(colorIndex);

    var rawSizeVal = sizeVal;
    var rawColorVal = colorVal;
    sizeVal = resolveColorValue(sliderEl, wrapperEl, sizeVal);
    colorVal = resolveColorValue(sliderEl, wrapperEl, colorVal);

    var mapNoEnV = parseMap(sliderEl.getAttribute('data-hc-map-no-en'));
    var mapEnNoV = parseMap(sliderEl.getAttribute('data-hc-map-en-no'));
    var sizeSet = sizeIndex >= 0 ? buildValueSet(sliderEl.getAttribute('data-size-values'), mapNoEnV, mapEnNoV, [rawSizeVal, sizeVal]) : null;
    var colorSet = colorIndex >= 0 ? buildValueSet(sliderEl.getAttribute('data-color-values'), mapNoEnV, mapEnNoV, [rawColorVal, colorVal]) : null;

    var slides = wrapperEl.querySelectorAll('.swiper-slide');
    var matches = [];
    var isMobile = window.innerWidth <= 768;

    Array.prototype.forEach.call(slides, function (slide) {
      var tokens = getSlideTokens(slide);
      var show = matchesDimension(tokens, sizeVal, sizeSet) && matchesDimension(tokens, colorVal, colorSet);

      if (show) matches.push(slide);
      slide.hidden = false;
      slide.classList.toggle('hc-img-show', show);
    });

    if (!matches.length && slides.length) {
      matches.push(slides[0]);
      slides[0].classList.add('hc-img-show');
    }

    if (isMobile) {
      wrapperEl.innerHTML = '';
      matches.forEach(function (slide) {
        slide.classList.add('hc-img-show');
        slide.hidden = false;
        wrapperEl.appendChild(slide);
      });
      return;
    }

    Array.prototype.forEach.call(slides, function (slide) {
      slide.hidden = !slide.classList.contains('hc-img-show');
    });
  }

  function refreshOne(sliderEl) {
    if (!sliderEl) return;

    filterSlides(sliderEl);

    if (window.innerWidth <= 768) {
      var swiper = initSwiper(sliderEl);
      if (swiper && swiper.update) {
        swiper.update();
        swiper.slideTo(0, false);
      }
    } else {
      destroySwiper(sliderEl);
    }

    sliderEl.classList.remove('hc-loading');
  }

  function refreshAll() {
    if (refreshAll.__scheduled) return;
    refreshAll.__scheduled = true;
    requestAnimationFrame(function () {
      refreshAll.__scheduled = false;
      var sliders = document.querySelectorAll('.hc-main-slider-vertical');
      Array.prototype.forEach.call(sliders, refreshOne);
    });
  }

  window.hcCustomVerticalGalleryRefresh = refreshAll;

  function boot() {
    refreshAll();

    ['variant:change', 'variant:select', 'variantChange', 'hcMainUpdate'].forEach(function (evt) {
      document.addEventListener(evt, refreshAll);
    });

    document.addEventListener('change', function (e) {
      if (!e.target) return;
      if (!e.target.matches('input[name^="options"], select[name^="options"], input[data-variant-input], select[data-variant-input]')) return;
      refreshAll();
    });

    window.addEventListener('resize', refreshAll);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
